import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getClientSettings, getTokens, useAuthState } from '../../contexts/auth';
import { getUser, storeUser } from '../../utils/tokens';
import * as R from 'ramda';
import { Dialog, Disclosure, Transition } from '@headlessui/react';
import React, { createRef, Fragment, useEffect, useMemo, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import { AlignRoutes } from '../Routes/AlignRoutes';
import axios from 'axios';
import { useClientSettingsDispatch, useClientSettingsState } from '../../contexts/client-settings';
import CategorySideNavigation from '../Categories/CategorySideNavigation';

const navigationMaster = [
	{
		title: 'MIND',
		href: '#',
		current: false,
		children: [],
	},
];

function classNames(...classes) {
	return classes.filter(Boolean).join(' ');
}

const listUrl = clientId => `resource/v1/resource-categories/clients/${clientId}?global=true`;

const AlignHome = () => {
	let navigate = useNavigate();
	const [queryParameters] = useSearchParams();

	const { isAuthenticated } = useAuthState();

	const [navigation, setNavigation] = useState(null);
	const [sidebarOpen, setSidebarOpen] = useState(false);
	const [categories, setCategories] = useState(null);
	const [loaded, setLoaded] = useState(false);
	const [currentUser, setCurrentUser] = useState(null);
	const [currentNav, setCurrentNav] = useState([]);
	const clientSettings = useClientSettingsState();
	const clientSettingsDispatch = useClientSettingsDispatch();

	useEffect(() => {
		//setAuthKey(queryParameters.get('authKey'));
		getTokens(queryParameters.get('authKey'))
			.then(() => {
				setCurrentUser(getUser());
				return getUser();
			})
			.then(user => {
				return getClientSettings(user.clientIdNum);
			})
			.then(settings => {
				clientSettingsDispatch(settings);
			});

		setNavigation([{enabled: true, global: true, id: -1, title: 'MIND Course', parentCategoryId: null}]);
	}, []);

	useEffect(() => {
		if (currentUser) {
			const getCategories = async () => {
				return await axios
					.get(listUrl(currentUser.clientIdNum))
					.then(response => {
						const filtered = R.filter(c => c.enabled, response.data);
						setCategories(filtered);
						return response.data;
					})
					.catch(error => {
						console.log(error);
					});
			};
			getCategories().then();
		}
	}, [clientSettings]);

	useEffect(() => {
		if (categories) {
			// split globals from locals
			const globals = R.filter(c => {
				return c.global === true;
			}, categories);

			let topGlobals = R.filter(c => !c.parentCategoryId, globals);
			R.forEach(c => {
				const kids = R.filter(c2 => c2.parentCategoryId === c.id, globals);
				c.children = kids.length ? kids : null;
			}, topGlobals);

			topGlobals = R.filter(c => {
				return c.enabledResourceCount > 0 || c.children;
			}, topGlobals);

			const locals = R.filter(c => c.global === false, categories);

			// add globals first
			// globals.forEach(c => {
			// 	navigation[0].children.push({ id: c.id, title: c.title, href: '#', global: true });
			// });

			const topLocals = R.filter(c => !c.parentCategoryId, locals);
			R.forEach(c => {
				const kids = R.filter(c2 => c2.parentCategoryId === c.id, locals);
				c.children = kids.length ? kids : null;
			}, topLocals);

			if (clientSettings.enableUIMindResources) {
				topGlobals.forEach(c => {
					navigation.push(c);
				});
			}

			topLocals.forEach(c => {
				navigation.push(c);
			});

			console.log(navigation, 'navigation');

			setLoaded(true);
		}
	}, [categories]);

	function selectNavBody(nav) {
		if (isAuthenticated) {
			if(nav.id === -1) {
				navigate(`course`);
			} else {
				updateCurrentNavigation(nav);

				nav.current = true;
				if (nav.global) {
					navigate(`resources/category/${nav.id}/global`);
				} else {
					navigate(`resources/category/${nav.id}/local`);
				}
			}
			
		}
	}

	function updateCurrentNavigation(nav) {
		currentNav.current = false;
		setCurrentNav(nav);

		const setCurrent = i => (i.current = false);
		R.forEach(setCurrent, navigation);

		nav.current = true;
	}

	function navHome() {
		navigate('/align');
	}

	if (!loaded) {
		return <div></div>; // zzmatt
	}

	return (
		<div>
			<AlignRoutes />
		</div>
	);
};

export default AlignHome;
